// assets/main-article-toc.js

(function () {
  const DEBUG = false;
  const log = (...args) => DEBUG && console.log('[TOC]', ...args);

  const sidebar = document.querySelector('.blog-sidebar');
  if (!sidebar) return;

  const tocScroll = sidebar.querySelector('.only-desktop');
  if (!tocScroll) return;

  const blogTocEl = tocScroll.querySelector('blog-toc.toc, blog-toc');
  if (!blogTocEl) return;

  const contentRoot = document.querySelector('.yv-blog-detail-desc');
  if (!contentRoot) return;

  // Headings to track
  const headings = Array.from(contentRoot.querySelectorAll('h2, h3, h4')).filter(
    (h) => (h.textContent || '').trim().length
  );

  if (!headings.length) return;

  // Ensure headings have IDs (so clicks can work if the component uses hashes later)
  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  headings.forEach((h) => {
    if (h.id) return;
    const base = slugify(h.textContent);
    if (!base) return;
    let id = base;
    let i = 2;
    while (document.getElementById(id)) {
      id = `${base}-${i++}`;
    }
    h.id = id;
  });

  // Find the TOC links container inside the custom element
  function getTocLinksContainer() {
    return blogTocEl.querySelector('.toc__links') || blogTocEl;
  }

  // Find a "toc item element" that best matches a heading text
  function findTocItemForHeading(headingText) {
    const container = getTocLinksContainer();
    if (!container) return null;

    const wanted = headingText.trim().toLowerCase();
    if (!wanted) return null;

    // Candidate clickable-ish nodes inside the toc list
    const candidates = Array.from(container.querySelectorAll('*')).filter((el) => {
      const t = (el.textContent || '').trim();
      if (!t) return false;
      // avoid huge wrapper nodes; prefer leaf-ish nodes
      if (el.children && el.children.length > 5) return false;
      return true;
    });

    if (!candidates.length) return null;

    // best match by substring / similarity
    let best = null;
    let bestScore = 0;

    for (const el of candidates) {
      const t = (el.textContent || '').trim().toLowerCase();
      if (!t) continue;

      let score = 0;
      if (t === wanted) {
        score = 100;
      } else if (t.includes(wanted) || wanted.includes(t)) {
        score = 70;
      } else {
        // simple overlap score
        const w = new Set(wanted.split(/\s+/));
        const s = new Set(t.split(/\s+/));
        let overlap = 0;
        w.forEach((x) => {
          if (s.has(x)) overlap++;
        });
        score = overlap;
      }

      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    }

    return bestScore > 0 ? best : null;
  }

  function scrollTocToElement(el) {
    if (!el) return;

    const cRect = tocScroll.getBoundingClientRect();
    const eRect = el.getBoundingClientRect();
    const pad = 24;

    const above = eRect.top - cRect.top;
    const below = eRect.bottom - cRect.bottom;

    const outOfView = above < pad || below > -pad;
    if (!outOfView) return;

    let delta = 0;
    if (above < pad) {
      delta = above - pad;
    } else if (below > -pad) {
      delta = below + pad;
    }

    tocScroll.scrollTo({ top: tocScroll.scrollTop + delta, behavior: 'smooth' });
  }

  // ScrollSpy: choose active heading based on scroll position
  let activeHeading = null;
  let ticking = false;

  function onScrollSpy() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      ticking = false;

      const threshold = 140;
      let best = null;

      for (const h of headings) {
        const top = h.getBoundingClientRect().top;
        if (top - threshold <= 0) {
          best = h;
        } else {
          break;
        }
      }

      if (!best) best = headings[0];

      if (best === activeHeading) return;
      activeHeading = best;

      // Find & scroll TOC item
      const tocItem = findTocItemForHeading(best.textContent || '');
      log('Active heading:', best.textContent, '-> tocItem:', tocItem ? tocItem.textContent.trim() : null);

      // Add active class for styling
      const container = getTocLinksContainer();
      if (container) {
        container.querySelectorAll('.is-active').forEach((n) => n.classList.remove('is-active'));
        if (tocItem) tocItem.classList.add('is-active');
      }

      scrollTocToElement(tocItem);
    });
  }

  window.addEventListener('scroll', onScrollSpy, { passive: true });

  // Wait until the blog-toc actually renders items into .toc__links
  const linksContainer = getTocLinksContainer();
  const mo = new MutationObserver(() => {
    onScrollSpy();
  });

  mo.observe(blogTocEl, { childList: true, subtree: true });

  // Initial run
  onScrollSpy();
})();